var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 48"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close-quote_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4741",
  fill: "#2c8530",
  d: "M0 0h60v48H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33629"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14126",
  clipPath: "url(#close-quote_svg__a)",
  transform: "rotate(180 30 24)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12904",
  d: "M26.993 34.447C26.993 42.635 21.259 48 13.567 48 5.734 48 0 42.494 0 34.447c0-3.671.559-6.353 3.776-14.118L11.888 0h13.846L19.58 22.447c4.616 1.977 7.413 6.212 7.413 12m33.007 0C60 42.635 54.266 48 46.573 48c-7.832 0-13.567-5.506-13.567-13.553 0-3.671.559-6.353 3.776-14.118L44.895 0h13.846l-6.154 22.447C57.2 24.424 60 28.659 60 34.447",
  fill: "#2c8530"
})))));
export default SvgCloseQuote;